import anime from 'animejs';

const portfolio = () => {
  let isOpen = false;
  // let animationComplete = false;
  let isAnimating = false
  const filterBtn = document.querySelector('.v-js-filters');

  // check if buttons exists
  // otherwise, get out
  if (!filterBtn) return;

  // handles filters opening / closing
  function toggleFilters() {

    // return out if animating
    if (isAnimating) return;

    const list = document.querySelector('.v-portfolio__filters-list');
    const listElements = list.querySelectorAll('.v-portfolio__filters-link');
    const listArrow = filterBtn.querySelector('.v-portfolio__filters-trigger-arrow');

    // open in order to get container height
    list.classList.remove('isClosed');
    list.classList.add('isOpen');
    const listElHeight = list.getBoundingClientRect().height;

    // setup animation timeline
    const animeTL = anime.timeline({
      easing: 'easeOutSine'
    });

    // open dropdown
    if (!isOpen) {

      // set flags and classes
      listArrow.classList.add('v-portfolio__filters-trigger-arrow--active')
      isAnimating = true

      // animate open
      animeTL.add({
        targets: list,
        height: [0, listElHeight],
        duration: 200,
        easing: 'easeOutSine'
      })
      .add({
        targets: listElements,
        opacity: [0, 1],
        delay: anime.stagger(50),
        duration: 250,
        easing: 'easeOutSine',
        complete: () => {

          // remove styles for height now that
          // has class w/ display block
          list.removeAttribute('style');

          // set flags
          isOpen = true;
          isAnimating = false;
        }
      }, '100');

    } else {

      // remove styles and classes
      listArrow.classList.remove('v-portfolio__filters-trigger-arrow--active');
      isAnimating = true;

      // animate close
      animeTL.add({
        targets: listElements,
        opacity: [1, 0],
        delay: anime.stagger(25, {direction: 'reverse'}),
        duration: 250,
      })
      .add({
        targets: list,
        height: [listElHeight, 0],
        duration: 250,
        complete: () => {

          // remove styles and classes
          list.classList.remove('isOpen');
          list.classList.add('isClosed');
          list.removeAttribute('style');

          // set flags
          isOpen = false;
          isAnimating = false;
        }
      }, '175');
    }
  }

  // listen for filter button click
  filterBtn.addEventListener('click', toggleFilters);

	document.addEventListener('facetwp-loaded', () => {
		const list = document.querySelector('.v-portfolio__filters-list');
		const listArrow = filterBtn.querySelector('.v-portfolio__filters-trigger-arrow');

		isOpen = false;
		isAnimating = false;
		listArrow.classList.remove('v-portfolio__filters-trigger-arrow--active');
		list.classList.remove('isOpen');
		list.classList.add('isClosed');
		list.removeAttribute('style');
	});
}

export default portfolio;